import { Page } from "@/components/Page";
import { PageHero } from "@/components/PageHero";
import { SpecialistsSection } from "@/components/SpecialistsSection";
import { WhyChoose } from "@/components/WhyChoose";
import { AppointmentSection } from "@/components/AppointmentSection";
import { STOCK } from "@/data/site";

export default function Specialists() {
  return (
    <Page>
      <PageHero
        crumb="Our Specialists"
        overline="Meet Our Team"
        title={"Meet Our\nSpecialists"}
        subtitle="Care delivered by qualified professionals dedicated to your movement, communication and hearing wellbeing."
        image={STOCK.physioManual}
      />
      <SpecialistsSection />
      <WhyChoose />
      <AppointmentSection />
    </Page>
  );
}
